import Label from "components/Label/Label";
import React, { Fragment, useState, useEffect } from "react";
import { useCart } from "context/CartContext";
import { Helmet } from "react-helmet-async";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import Input from "shared/Input/Input";
import Textarea from "shared/Textarea/Textarea";
import * as Yup from "yup";
import { useFormik } from "formik";
import {
  clearData,
  getList as onGetList,
  addNewData as onAddNewData,
} from "store/AppMaster/actions";
import api from "constants/api";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
import { RootState } from "store/reducers";
import { useRazorpay, RazorpayOrderOptions } from "react-razorpay";
import SkewLoader from "react-spinners/SkewLoader"; // Add this import

const CheckoutPage = () => {
  const dispatch = useDispatch();
  const { data, loading } = useSelector((state: RootState) => ({
    data: state.AppMaster.data,
    loading: state.AppMaster.loading,
  }));
  const [isLoading, setIsLoading] = useState(true);
  const { error: razorpayError, isLoading: razorpayLoading, Razorpay } = useRazorpay();
  const [cartData, setCartData] = useState<any>(null);
  const navigate = useNavigate();
  const { setCart, setTotalPrice, cart, totalPrice, updateCart, removeFromCart, increaseQuantity, decreaseQuantity, handleProductTypeSelection, showTotalPrice, totalDiscount } = useCart();
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);
  const [showThankYouBlock, setShowThankYouBlock] = useState(false);
  const [localTotalPrice, setLocalTotalPrice] = useState(0);
  const [localTotalDiscount, setLocalTotalDiscount] = useState(0);
  const [authUserName, setAuthName] = useState("");
  const [authUserEmail, setAuthEmail] = useState("");
  const [selectedType, setSelectedType] = useState("");
  const [userDetails, setUserDetails] = useState([]);
  // const [deliveryPartnerError, setDeliveryPartnerError] = useState(""); // Add this state
  const [productType, setProductType] = useState("pending");
  const [specialMessage, setSpecialMessage] = useState("");
  const [showProducts, setShowProducts] = useState(false);
  const [odooOrderName, setOdooOrderName] = useState<string>("");
  const [filterData, setFilterData] = useState({
    start: 0,
    limit: 10,
    search: '',
    sort_by: "_id",
    sort_order: "desc",
  });
  // const [dropdownOptions, setDropdownOptions] = useState<{ id: string; name: string; price: number }[]>([]);
  const [selectedOption, setSelectedOption] = useState<string>("");
  // const [deliveryCharge, setDeliveryCharge] = useState<number>(0);
  const [razorpayOrderId, setRazorpayOrderId] = useState<string | null>(null);
  const [paymentValue, setPaymentValue] = useState<number | null>(null);
  const [frmData, setFrmData] = useState({
    name: authUserName,
    email: authUserEmail,
    mobile: "",
    designation: "",
    company: "",
    city: "",
    address: "",
    additional_address: "",
    state: "",
    country: "",
    pincode: "",
    subject: "",
    po_no: "",
    message: "",
    cart_items: cartData,
    status: "Unread"
  });
  const [showMoreHelpPopup, setShowMoreHelpPopup] = useState(false);
  const [moreHelpMessage, setMoreHelpMessage] = useState("");
  const [moreHelpError, setMoreHelpError] = useState("");
  const [moreHelpLoading, setMoreHelpLoading] = useState(false);
  const [isQuotationLoading, setIsQuotationLoading] = useState(false); // Add this new state
  const color = "#06163A"; // Add color for the loader
  const [isConfirmLoading, setIsConfirmLoading] = useState(false);
  const [useSameAsBilling, setUseSameAsBilling] = useState(true);
  // const [deliveryName, setDeliveryName] = useState("");
  // const [deliveryEmail, setDeliveryEmail] = useState("");
  // const [deliveryMobile, setDeliveryMobile] = useState("");
  const [deliveryCompany, setDeliveryCompany] = useState("");
  const [deliveryCity, setDeliveryCity] = useState("");
  const [deliverySubject, setDeliverySubject] = useState("");
  const [deliveryPoNo, setDeliveryPoNo] = useState("");
  const [deliveryAddress, setDeliveryAddress] = useState("");
  const [deliveryAdditionalAddress, setDeliveryAdditionalAddress] = useState("");
  const [deliveryState, setDeliveryState] = useState("");
  const [deliveryCountry, setDeliveryCountry] = useState("");
  const [deliveryPincode, setDeliveryPincode] = useState("");
  const [showPartDeliveryPopup, setShowPartDeliveryPopup] = useState(false);
  const [partDeliveryChoice, setPartDeliveryChoice] = useState<"yes" | "no" | null>(null);

  useEffect(() => {
    if (showSuccessPopup) {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  }, [showSuccessPopup]);

  useEffect(() => {
    if (useSameAsBilling) {
      // setDeliveryName(frmData.name || "");
      // setDeliveryEmail(frmData.email || "");
      // setDeliveryMobile(frmData.mobile || "");
      setDeliveryCompany(frmData.company || "");
      setDeliveryCity(frmData.city || "");
      setDeliveryAddress(frmData.address || "");
      setDeliveryAdditionalAddress(frmData.additional_address || "");
      setDeliveryState(frmData.state || "");
      setDeliveryCountry(frmData.country || "");
      setDeliveryPincode(frmData.pincode || "");
      setDeliverySubject(frmData.subject || "");
      setDeliveryPoNo(frmData.po_no || "");
    }
  }, [useSameAsBilling, frmData.name, frmData.email, frmData.mobile, frmData.company, frmData.city, frmData.address, frmData.additional_address, frmData.state, frmData.country, frmData.pincode, frmData.subject, frmData.po_no]);

  useEffect(() => {
    if (localStorage.getItem("AuthCustomerDetails")) {
      const authUserDetails = JSON.parse(localStorage.getItem("AuthCustomerDetails") || "{}");
      setAuthName(authUserDetails.first_name + ' ' + authUserDetails.last_name);
      setUserDetails(authUserDetails);
      setAuthEmail(authUserDetails.email);
      setFrmData((prev) => ({
        ...prev,
        name: authUserDetails.first_name + ' ' + authUserDetails.last_name,
        email: authUserDetails.email,
        mobile: authUserDetails.mobile,
        designation: authUserDetails.designation,
        company: authUserDetails.company_name,
        city: authUserDetails.city || "", // Assuming 'city' property exists in authUserDetails; adjust if different (e.g., company_city)
        address: authUserDetails.company_address,
        additional_address: authUserDetails.additional_address,
        state: authUserDetails.state,
        country: authUserDetails.country,
        pincode: authUserDetails.pincode,
        subject: "",
        po_no: "",
        message: ""
      }));
      setSpecialMessage(authUserDetails.special_message);
    }
  }, []); // Changed dependency to [] to run only once on mount

  // const getCartData = () => {
  //   const email = JSON.parse(localStorage.getItem("AuthCustomerDetails") || "{}").email;
  //   if (email) {
  //     dispatch(clearData());
  //     dispatch(onGetList({ email }, "", api.frontEndCartData));
  //   }
  // };
  const getCartData = async () => {
    setIsLoading(true);
    const email = JSON.parse(localStorage.getItem("AuthCustomerDetails") || "{}").email;
    const token = JSON.parse(localStorage.getItem("AuthCustomer") || "{}");
    try {
      const response = await fetch(process.env.REACT_APP_API_URL + api.frontEndCartData, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ email, refresh_stock: true }),
      });
      const result = await response.json();
      if (response.status === 401) {
        console.error("Unauthorized: Invalid or missing token");
        navigate("/login");
        return;
      }
      if (result.statusCode === 200 && result.data.cart && result.data.cart.length > 0) {
        const cartItems = result.data.cart[0].detailed_codes || [];
        const count = result.data.cart[0].count || 0;
        setCart(cartItems, count);
        setCartData(result.data.cart[0]); // Store the complete cart data
        localStorage.setItem("cart", JSON.stringify(cartItems));
        // Removed localStorage.setItem("cartCount", ...) as it's no longer needed
      } else {
        setCart([], 0);
        setCartData(null);
      }
    } catch (error) {
      console.error("Failed to fetch cart data:", error);
      setCart([], 0);
      setCartData(null);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getCartData();
  }, []);

  // useEffect(() => {
  //   const fetchDeliveryPartners = async () => {
  //     try {
  //       const token = localStorage.getItem("AuthCustomer");
  //       if (!token) {
  //         console.log("No authentication token found in localStorage.");
  //         return;
  //       }

  //       const url = `${process.env.REACT_APP_API_URL}${api.getDeliveryPartnerList}`;
  //       const response = await fetch(url, {
  //         method: 'POST',
  //         headers: {
  //           "Content-Type": "application/json",
  //           "Authorization": `Bearer ${token.replace(/"/g, '')}`,
  //         },
  //         body: JSON.stringify(filterData)
  //       });

  //       if (!response.ok) {
  //         throw new Error(`Network response was not ok: ${response.statusText}`);
  //       }

  //       const responseData = await response.json();
  //       // console.log("API Response for Delivery Partners:", responseData);

  //       if (responseData?.data?.result && Array.isArray(responseData.data.result)) {
  //         const options = responseData.data.result
  //           .filter((item: any) => item.status === "Active")
  //           .map((item: any) => ({
  //             id: item._id,
  //             name: item.name,
  //             price: item.per_weight_charge || 0,
  //           }));
  //         setDropdownOptions(options);
  //         // console.log("Dropdown options set:", options);
  //       } else {
  //         console.error("API did not return the expected 'data.result' array.", responseData);
  //         setDropdownOptions([]);
  //       }
  //     } catch (error) {
  //       console.error("Failed to fetch delivery partners:", error);
  //       setDropdownOptions([]);
  //     }
  //   };

  //   fetchDeliveryPartners();
  // }, []);

  // useEffect(() => {
  //   if (selectedOption && cartData?.weight && dropdownOptions.length > 0) {
  //     const selectedPartner = dropdownOptions.find(opt => opt.id === selectedOption);
  //     if (selectedPartner?.price) {
  //       const weightInGrams = Math.ceil(cartData.weight || 0);
  //       const pricePerKg = selectedPartner.price;
  //       const charge = (weightInGrams) * pricePerKg;
  //       setDeliveryCharge(charge);
  //     } else {
  //       setDeliveryCharge(0);
  //     }
  //   } else {
  //     setDeliveryCharge(0);
  //   }
  // }, [selectedOption, dropdownOptions, cartData]);

  useEffect(() => {
    if (cartData) {
      setCartData(cartData);
    }
  }, [cartData]);

  const onChangeHandler = (event: any) => {
    const { name, value } = event.target;
    setFrmData((preValue) => ({
      ...preValue,
      [name]: value,
    }));
  };

  const onDeliveryChangeHandler = (event: any) => {
    const { name, value } = event.target;
    switch (name) {
      // case "name":
      //   setDeliveryName(value);
      //   break;
      // case "email":
      //   setDeliveryEmail(value);
      //   break;
      // case "mobile":
      //   setDeliveryMobile(value);
      //   break;
      case "company":
        setDeliveryCompany(value);
        break;
      case "city":
        setDeliveryCity(value);
        break;
      case "subject":
        setDeliverySubject(value);
        break;
      case "po_no":
        setDeliveryPoNo(value);
        break;
      case "address":
        setDeliveryAddress(value);
        break;
      case "additional_address":
        setDeliveryAdditionalAddress(value);
        break;
      case "state":
        setDeliveryState(value);
        break;
      case "country":
        setDeliveryCountry(value);
        break;
      case "pincode":
        setDeliveryPincode(value);
        break;
      default:
        break;
    }
  };

  const handleCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setUseSameAsBilling(e.target.checked);
    if (e.target.checked) {
      // setDeliveryName(frmData.name || "");
      // setDeliveryEmail(frmData.email || "");
      // setDeliveryMobile(frmData.mobile || "");
      setDeliveryCompany(frmData.company || "");
      setDeliveryCity(frmData.city || "");
      setDeliveryAddress(frmData.address || "");
      setDeliveryAdditionalAddress(frmData.additional_address || "");
      setDeliveryState(frmData.state || "");
      setDeliveryCountry(frmData.country || "");
      setDeliveryPincode(frmData.pincode || "");
      setDeliverySubject(frmData.subject || "");
      setDeliveryPoNo(frmData.po_no || "");
    }
  };

  const handlePayment = (orderData: any, razorpayOrderId: string) => {
    setIsConfirmLoading(true); // Start loading when payment is initiated

    const razorpayKey = process.env.REACT_APP_RAZORPAY_KEY;
    if (!razorpayKey) {
      console.error("Razorpay is not accessible");
      setIsConfirmLoading(false);
      return;
    }

    const options: RazorpayOrderOptions = {
      key: razorpayKey, // Replace with your Razorpay key
      amount: ((data?.cart?.[0]?.total || 0) * 100), // Convert to paise
      currency: "INR",
      name: "Vijaydeep",
      description: "Checkout Payment",
      order_id: razorpayOrderId,
      handler: async (response) => {
        // console.log("Payment Response:", response);

        try {
          // Dispatch the API call to verify the payment
          const token = localStorage.getItem("AuthCustomer");
          if (!token) {
            throw new Error("No authentication token found in localStorage.");
          }
          const verificationResponse = await fetch(`${process.env.REACT_APP_API_URL}${api.verifyRazorpayPayment}`, {
            method: 'POST',
            headers: {
              "Content-Type": "application/json",
              "Authorization": `Bearer ${token.replace(/"/g, '')}`,
            },
            body: JSON.stringify({
              razorpay_order_id: response.razorpay_order_id,
              razorpay_payment_id: response.razorpay_payment_id,
              razorpay_signature: response.razorpay_signature,
              orderData,
              total_value_after_discount: (cartData?.total || 0),
            }),
          });
          // Access the data from the payload
          const result = await verificationResponse.json();
          // console.log("Verification Data:", data); // Add this to debug
          // Update state with the verified data
          setRazorpayOrderId(result.razorpay_order_id);
          setPaymentValue(result.payment_value);
          // console.log("Updated paymentValue:", data.total_value_after_discount);
          // Clear cart and update UI
          localStorage.setItem("cart", "");
          localStorage.setItem("Total Price", "");
          setCart([]);
          setTotalPrice(0);
          updateCart();
          setShowSuccessPopup(true);
        } catch (error) {
          console.error("Payment verification failed:", error);
        } finally {
          setIsConfirmLoading(false); // Stop loading after payment processing
        }
      },
      modal: {
        ondismiss: () => {
          setIsConfirmLoading(false); // Stop loading if user dismisses the modal
        }
      },
      prefill: {
        name: frmData.name,
        email: frmData.email,
        contact: frmData.mobile,
      },
      theme: {
        color: "#F37254",
      },
    };

    const razorpayInstance = new Razorpay(options);
    razorpayInstance.open();
  };

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      name: (frmData && frmData.name) || "",
      email: (frmData && frmData.email) || "",
      mobile: (frmData && frmData.mobile) || "",
      designation: (frmData && frmData.designation) || "",
      company: (frmData && frmData.company) || "",
      city: (frmData && frmData.city) || "",
      address: (frmData && frmData.address) || "",
      additional_address: (frmData && frmData.additional_address) || "",
      state: (frmData && frmData.state) || "",
      country: (frmData && frmData.country) || "",
      pincode: (frmData && frmData.pincode) || "",
      subject: (frmData && frmData.subject) || "",
      po_no: (frmData && frmData.po_no) || "",
      message: (frmData && frmData.message) || "",
      cart_items: (frmData && frmData.cart_items) || "",
      status: (frmData && frmData.status) || "",
      total_value: totalPrice ? totalPrice : localTotalPrice,
      total_value_after_discount: (totalPrice ? totalPrice : localTotalPrice) - (totalDiscount ? totalDiscount : localTotalDiscount)
    },
    validationSchema: Yup.object({
      name: Yup.string().required("Please Enter Name").matches(
        /^[A-Za-z ]+$/i,
        "Must be a valid Name"
      ).max(50, "Must be less than 50 characters"),
      email: Yup.string().required("Please Enter Email").matches(
        /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
        "Must be a valid Email"
      ),
      mobile: Yup.string().required("Please Enter Mobile").matches(
        /^[+0-9]+$/i,
        "Please Enter Valid Mobile"
      ).min(9, "Please Enter Valid Mobile").max(12, "Please Enter Valid Mobile"),
      city: Yup.string().required("Please Enter City"),
      address: Yup.string().required("Please Enter Address"),
      // additional_address: Yup.string().required("Please Enter Additional Address"),
      additional_address: Yup.string().nullable(), // or .notRequired()
      state: Yup.string().required("Please Enter State"),
      country: Yup.string().required("Please Enter Country"),
      pincode: Yup.string().required("Please Enter Pincode").matches(
        /^[0-9]{6}$/,
        "Pincode should be 6 digits"
      ),
      // message: Yup.string().required("Please Enter Message")
    }),
    onSubmit: async (values) => {
      // Make delivery partner selection compulsory
      // if (!selectedOption) {
      //   setDeliveryPartnerError("Please select a delivery partner.");
      //   return;
      // }
      // setDeliveryPartnerError(""); // Clear error if selected

      // Validate delivery details if different from billing
      if (!useSameAsBilling) {
        // if (!deliveryName.trim()) {
        //   alert("Delivery name is required");
        //   return;
        // }
        // if (!deliveryEmail.trim()) {
        //   alert("Delivery email is required");
        //   return;
        // }
        // if (!deliveryMobile.trim()) {
        //   alert("Delivery mobile is required");
        //   return;
        // }
        // if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(deliveryEmail)) {
        //   alert("Delivery email must be valid");
        //   return;
        // }
        // if (!/^[+0-9]+$/i.test(deliveryMobile) || deliveryMobile.length < 9 || deliveryMobile.length > 12) {
        //   alert("Delivery mobile must be valid");
        //   return;
        // }
        if (!deliveryCity.trim()) {
          alert("Delivery city is required");
          return;
        }
        if (!deliveryAddress.trim()) {
          alert("Delivery address is required");
          return;
        }
        if (!deliveryState.trim()) {
          alert("Delivery state is required");
          return;
        }
        if (!deliveryCountry.trim()) {
          alert("Delivery country is required");
          return;
        }
        if (!deliveryPincode || deliveryPincode.toString().length !== 6) {
          alert("Valid delivery pincode is required");
          return;
        }
      }

      // Get delivery partner name from dropdownOptions
      // const selectedPartnerObj = dropdownOptions.find(opt => opt.id === selectedOption);
      // const deliveryPartnerName = selectedPartnerObj ? selectedPartnerObj.name : "";

      const productCodes = cartData?.detailed_codes || [];
      const basePayload = {
        name: values["name"],
        email: values["email"],
        mobile: values["mobile"],
        designation: values["designation"],
        company: values["company"],
        city: values["city"],
        address: values["address"],
        additional_address: values["additional_address"],
        state: values["state"],
        country: values["country"],
        pincode: values["pincode"],
        subject: useSameAsBilling ? frmData.subject : deliverySubject,
        po_no: useSameAsBilling ? frmData.po_no : deliveryPoNo,
        message: selectedType === "confirm" ? "paid" : values["message"],
        cart_items: JSON.stringify(productCodes),
        status: values["status"],
        type: selectedType,
        total_value: (cartData?.subtotal?.toFixed(2)),
        total_value_after_discount: (cartData?.total),
        // delivery_company: useSameAsBilling ? values["company"] : deliveryCompany,
        // delivery_address: useSameAsBilling ? values["address"] : deliveryAddress,
        // delivery_state: useSameAsBilling ? values["state"] : deliveryState,
        // delivery_pincode: useSameAsBilling ? values["pincode"] : deliveryPincode,
        // delivery_country: useSameAsBilling ? values["country"] : deliveryCountry,
        delivery_company: deliveryCompany,
        delivery_city: deliveryCity,
        delivery_address: deliveryAddress,
        deliveryAdditionalAddress: deliveryAdditionalAddress,
        delivery_state: deliveryState,
        delivery_pincode: deliveryPincode,
        delivery_country: deliveryCountry,
        delivery_partner: cartData?.delivery_partner || "",
        delivery_charges: cartData?.delivery_charges || 0,
        // delivery_charge: deliveryCharge.toFixed(2),
        // delivery_partner: deliveryPartnerName,
        // delivery_charges: deliveryCharge.toFixed(2),
        payment_terms: cartData?.payment_terms || "", // <-- Use value from cart collection
        "log_note": partDeliveryChoice === "yes"
          ? "User is willing to accept part delivery of this order"
          : "",
      };

      const paymentTerms = cartData?.payment_terms;
      const isAdvancePayment = paymentTerms === "100% Advance Against Pro-Forma";

      if (selectedType === "confirm") {
        setIsConfirmLoading(true); // Start loading when confirm is clicked

        try {
          const token = localStorage.getItem("AuthCustomer")?.replace(/"/g, '');

          // CASE 1: 100% Advance → Use Razorpay
          if (isAdvancePayment) {
            // Step 1: Create Razorpay Order
            const razorpayRes = await fetch(`${process.env.REACT_APP_API_URL}${api.createRazorpayOrder}`, {
              method: 'POST',
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
              },
              body: JSON.stringify({
                total_value_after_discount: cartData?.total,
                currency: "INR",
                order_number: `ADV-${Date.now()}`, // temporary receipt
              }),
            });

            if (!razorpayRes.ok) throw new Error("Failed to create payment order");

            const { order_id } = await razorpayRes.json();

            const options: RazorpayOrderOptions = {
              key: process.env.REACT_APP_RAZORPAY_KEY!,
              amount: cartData?.total * 100,
              currency: "INR",
              name: "Vijaydeep",
              description: "Order Payment - 100% Advance",
              order_id,
              handler: async (response) => {
                try {
                  // 1. Verify payment first
                  const verifyRes = await fetch(`${process.env.REACT_APP_API_URL}${api.verifyRazorpayPayment}`, {
                    method: 'POST',
                    headers: {
                      "Content-Type": "application/json",
                      Authorization: `Bearer ${token}`,
                    },
                    body: JSON.stringify({
                      razorpay_order_id: response.razorpay_order_id,
                      razorpay_payment_id: response.razorpay_payment_id,
                      razorpay_signature: response.razorpay_signature,
                      total_value_after_discount: cartData?.total,
                      email: frmData.email,
                    }),
                  });

                  const verifyData = await verifyRes.json();

                  if (!verifyData.success) {
                    alert("Payment verification failed");
                    return;
                  }

                  const enquiryRes = await fetch(`${process.env.REACT_APP_API_URL}${api.frontEnquiry}`, {
                    method: 'POST',
                    headers: {
                      "Content-Type": "application/json",
                      Authorization: `Bearer ${token}`,
                    },
                    body: JSON.stringify({
                      ...basePayload,
                      message: "paid",
                      razorpay_order_id: response.razorpay_order_id,
                      razorpay_payment_id: response.razorpay_payment_id,
                    }),
                  });

                  const enquiryData = await enquiryRes.json();

                  // This is your REAL order number
                  const realOrderNumber = enquiryData?.data?.order_number || "N/A";
                  const odooName = enquiryData?.data?.odoo_display_name || realOrderNumber;

                  // Show the REAL order number in success message
                  setOdooOrderName(odooName);           // e.g. SO01234
                  setRazorpayOrderId(response.razorpay_payment_id);
                  setPaymentValue(cartData?.total);

                  // Clear cart
                  localStorage.removeItem("cart");
                  localStorage.removeItem("Total Price");
                  setCart([]);
                  setTotalPrice(0);
                  updateCart();

                  setShowSuccessPopup(true);

                } catch (err) {
                  console.error(err);
                  alert("Order creation failed after payment");
                } finally {
                  setIsConfirmLoading(false);
                }
              },
              modal: {
                ondismiss: () => {
                  setIsConfirmLoading(false);
                  alert("Payment cancelled. No order placed.");
                },
              },
              prefill: { name: frmData.name, email: frmData.email, contact: frmData.mobile },
              theme: { color: "#F37254" },
            };

            const rzp = new (window as any).Razorpay(options);
            rzp.open();

          }
          // CASE 2: NOT Advance → Directly place order (no Razorpay)
          else {
            const enquiryRes = await fetch(`${process.env.REACT_APP_API_URL}${api.frontEnquiry}`, {
              method: 'POST',
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
              },
              body: JSON.stringify(basePayload), // No razorpay fields here
            });

            if (!enquiryRes.ok) {
              throw new Error("Failed to create order");
            }

            const enquiryData = await enquiryRes.json();
            const odooName = enquiryData.data?.odoo_display_name || enquiryData.data?.order_number || "N/A";

            setOdooOrderName(odooName);
            setPaymentValue(cartData?.total);

            // Clear cart
            localStorage.removeItem("cart");
            localStorage.removeItem("Total Price");
            setCart([]);
            setTotalPrice(0);
            updateCart();

            setShowSuccessPopup(true);
            setIsConfirmLoading(false);
          }
        } catch (error: any) {
          console.error(error);
          alert("Failed to initiate payment: " + error.message);
          setIsConfirmLoading(false);
        }

      } else {
        // For Quotation / More Help → keep old logic
        dispatch(onAddNewData(basePayload, "", api.frontEnquiry));
        localStorage.removeItem("cart");
        localStorage.removeItem("Total Price");
        setCart([]);
        setTotalPrice(0);
        updateCart();
        setShowSuccessPopup(true);
      }
    },
  });

  const handleCheckoutClick = (e: any) => {
    e.preventDefault();
    const { name } = e.target;
    setSelectedType(name);
    if (name === "confirm") {
      // Check if all products are in ready stock or if there's only one item
      const detailedCodes = cartData?.detailed_codes || [];
      const isSingleItem = detailedCodes.length === 1;
      const allProductsInReadyStock = detailedCodes.every((item: { quantity_on_hand: number; no_lead_day: number }) =>
        item.quantity_on_hand > 0 && item.no_lead_day === 0
      );

      // Hide part delivery option if all products are in ready stock or single item
      if (allProductsInReadyStock || isSingleItem) {
        setPartDeliveryChoice("no"); // Auto-set to no
        validation.handleSubmit(); // Directly submit without showing popup
        return;
      }

      setShowPartDeliveryPopup(true); // Show the popup for other cases
      return;
    }
    if (cart.length > 0) {
      validation.handleSubmit();
    } else {
      navigate('/checkout');
    }
  };

  const handlePartDeliveryChoice = (choice: "yes" | "no") => {
    setPartDeliveryChoice(choice);
    setShowPartDeliveryPopup(false);
    // After closing popup, submit the form
    setTimeout(() => {
      validation.handleSubmit();
    }, 0);
  };

  const handleMoreHelpClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    setShowMoreHelpPopup(true);
    setMoreHelpMessage("");
    setMoreHelpError("");
  };

  const handleMoreHelpSubmit = async () => {
    // if (!selectedOption) {
    //   setDeliveryPartnerError("Please select a delivery partner.");
    //   return;
    // }
    if (!moreHelpMessage.trim()) {
      setMoreHelpError("Message is required.");
      return;
    }
    setMoreHelpLoading(true);
    setMoreHelpError("");
    // setDeliveryPartnerError(""); // Clear error if selected
    try {
      const token = localStorage.getItem("AuthCustomer");
      if (!token) throw new Error("No authentication token found.");
      const productCodes = cartData?.detailed_codes || [];
      // const selectedPartnerObj = dropdownOptions.find(opt => opt.id === selectedOption);
      // const deliveryPartnerName = selectedPartnerObj ? selectedPartnerObj.name : "";
      const payload = {
        name: frmData.name,
        email: frmData.email,
        mobile: frmData.mobile,
        designation: frmData.designation,
        company: frmData.company,
        city: frmData.city,
        address: frmData.address,
        additional_address: frmData.additional_address,
        state: frmData.state,
        country: frmData.country,
        pincode: frmData.pincode,
        subject: useSameAsBilling ? frmData.subject : deliverySubject,
        po_no: useSameAsBilling ? frmData.po_no : deliveryPoNo,
        message: moreHelpMessage,
        cart_items: JSON.stringify(productCodes),
        status: frmData.status,
        type: "morehelp",
        total_value: cartData?.subtotal?.toFixed(2),
        total_value_after_discount: (cartData?.total),
        delivery_company: deliveryCompany,
        delivery_city: deliveryCity,
        delivery_address: deliveryAddress,
        deliveryAdditionalAddress: deliveryAdditionalAddress,
        delivery_state: deliveryState,
        delivery_pincode: deliveryPincode,
        delivery_country: deliveryCountry,
        delivery_partner: cartData?.delivery_partner || "",
        delivery_charges: cartData?.delivery_charges || 0,
        // delivery_charge: deliveryCharge.toFixed(2),
        // delivery_partner: deliveryPartnerName,
        // delivery_charges: deliveryCharge.toFixed(2),
        payment_terms: cartData?.payment_terms || "", // <-- Use value from cart collection
      };
      const response = await fetch(`${process.env.REACT_APP_API_URL}${api.frontEnquiry}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token.replace(/"/g, '')}`,
        },
        body: JSON.stringify(payload),
      });
      if (!response.ok) throw new Error("Failed to submit More Help request.");
      setShowMoreHelpPopup(false);
      setShowSuccessPopup(true);
      navigate('/more-help'); // <-- Add navigation here
    } catch (err) {
      setMoreHelpError("Failed to submit. Please try again.");
    } finally {
      setMoreHelpLoading(false);
    }
  };

  const handleSubmit = (e: any) => {
    e.preventDefault();
    if (cart.length > 0) { // Changed from cartCount > 0
      validation.handleSubmit();
    } else {
      navigate('/checkout');
    }
  };

  const renderProduct = (item: any, index: number) => {
    const { code, price, weight, quantity, discount, category, quantity_on_hand } = item;
    const isInStock = quantity_on_hand >= quantity;
    return (
      <div key={index} className="relative flex p-5 items-center sm:items-start">
        <div className="ml-3 sm:ml-6 flex flex-1 flex-col">
          <div>
            <div className="flex justify-between">
              <div className="flex-[1.5]">
                <h3 className="text-base font-semibold">
                  {category?.display_name || code}
                </h3>
                <p className="text-sm text-gray-500">Code: {code}</p>
                <p className="text-sm text-gray-500">Quantity: {quantity}</p>
                <p className="text-sm text-gray-500">
                  {isInStock ? "In Stock" : "Sold Out"}
                </p>
              </div>
            </div>
          </div>
          <div className="flex justify-between mt-auto pt-4 text-sm">
            <h3 className="text-base font-medium">
              Price: ₹ {(price * quantity).toFixed(2)}
            </h3>
          </div>
          <div className="flex justify-between mt-auto pt-2 text-sm">
            <h3 className="text-base font-medium">
              Discount: {discount}%
            </h3>
          </div>
          <div className="flex justify-between mt-auto pt-2 text-sm">
            <h3 className="text-base font-medium">
              Weight: {(weight * quantity).toFixed(3)} kg
            </h3>
          </div>
        </div>
      </div>
    );
  };

  const handleQuotationClick = async (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();

    // Check if delivery partner is selected
    // if (!selectedOption) {
    //   setDeliveryPartnerError("Please select a delivery partner.");
    //   return;
    // }

    setIsQuotationLoading(true); // Start loading

    // Prepare the payload for api.frontEnquiry
    const token = localStorage.getItem("AuthCustomer");
    const email = JSON.parse(localStorage.getItem("AuthCustomerDetails") || "{}").email;
    const productCodes = cartData?.detailed_codes || [];
    // const selectedPartnerObj = dropdownOptions.find(opt => opt.id === selectedOption);
    // const deliveryPartnerName = selectedPartnerObj ? selectedPartnerObj.name : "";

    const payload = {
      name: frmData.name,
      email: frmData.email,
      mobile: frmData.mobile,
      designation: frmData.designation,
      company: frmData.company,
      city: frmData.city,
      address: frmData.address,
      additional_address: frmData.additional_address,
      state: frmData.state,
      country: frmData.country,
      pincode: frmData.pincode,
      subject: useSameAsBilling ? frmData.subject : deliverySubject,
      po_no: useSameAsBilling ? frmData.po_no : deliveryPoNo,
      message: "Quotation created",
      cart_items: JSON.stringify(productCodes),
      status: frmData.status,
      type: "quotation",
      total_value: cartData?.subtotal?.toFixed(2),
      total_value_after_discount: (cartData?.total),
      delivery_company: deliveryCompany,
      delivery_city: deliveryCity,
      delivery_address: deliveryAddress,
      deliveryAdditionalAddress: deliveryAdditionalAddress,
      delivery_state: deliveryState,
      delivery_pincode: deliveryPincode,
      delivery_country: deliveryCountry,
      delivery_partner: cartData?.delivery_partner || "",
      delivery_charges: cartData?.delivery_charges || 0,
      // delivery_charge: deliveryCharge.toFixed(2),
      // delivery_partner: deliveryPartnerName,
      // delivery_charges: deliveryCharge.toFixed(2),
      payment_terms: cartData?.payment_terms || "", // <-- Use value from cart collection
    };

    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}${api.frontEnquiry}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token?.replace(/"/g, '')}`,
        },
        body: JSON.stringify(payload),
      });
      const result = await response.json();
      const orderId = result?.data?._id;
      if (orderId) {
        window.open(`/admin/enquiry-pdf/${orderId}`, '_blank');
      } else {
        alert("Order ID not found!");
      }
    } catch (error) {
      alert("Failed to create enquiry or fetch order ID!");
    } finally {
      setIsQuotationLoading(false); // Stop loading
    }
  };

  const renderLeft = () => {
    return (
      <div className="space-y-8">
        {/* {specialMessage && (
          <div className="bg-yellow-200 text-yellow-800 p-4 rounded-md border border-yellow-400">
            {specialMessage}
          </div>
        )} */}
        <div id="ShippingAddress" className="scroll-mt-24">
          <div className="border border-slate-200 dark:border-slate-700 rounded-xl">
            <div className="px-6 py-7 space-y-4 sm:space-y-6 block">
              <h3 className="text-lg font-semibold">Billing Details</h3>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-3">
                <div>
                  <Label className="text-sm">Name<span className="text-rose-600">*</span></Label>
                  <Input className="mt-1.5" placeholder="Name" name="name" onChange={onChangeHandler} value={frmData.name} />
                  {validation.errors.name && <small className="text-rose-600">{validation.errors.name}</small>}
                </div>
                <div>
                  <Label className="text-sm">Email<span className="text-rose-600">*</span></Label>
                  <Input className="mt-1.5" type="email" name="email" placeholder="Email" onChange={onChangeHandler} value={frmData.email} />
                  {validation.errors.email && <small className="text-rose-600">{validation.errors.email}</small>}
                </div>
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-3">
                <div>
                  <Label>Phone Number<span className="text-rose-600">*</span></Label>
                  <div className="mt-1.5 flex">
                    <span className="inline-flex items-center px-2.5 rounded-l-2xl border border-r-0 border-neutral-200 dark:border-neutral-700 bg-slate-100 dark:bg-neutral-800 text-neutral-500 dark:text-neutral-400 text-sm">
                      <i className="text-2xl las la-phone-volume"></i>
                    </span>
                    <Input name="mobile" className="!rounded-l-none" placeholder="003 888 232" onChange={onChangeHandler} value={frmData.mobile} />
                  </div>
                  {validation.errors.mobile && <small className="text-rose-600">{validation.errors.mobile}</small>}
                </div>
                <div>
                  <Label className="text-sm">Designation</Label>
                  <Input className="mt-1.5" name="designation" type="text" placeholder="Designation" onChange={onChangeHandler} value={frmData.designation} />
                </div>
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-3">
                <div>
                  <Label className="text-sm">Company</Label>
                  <Input className="mt-1.5" name="company" type="text" placeholder="Company" onChange={onChangeHandler} value={frmData.company} />
                </div>
                <div>
                  <Label className="text-sm">Billing City<span className="text-rose-600">*</span></Label>
                  <Input className="mt-1.5" name="city" type="text" placeholder="City" onChange={onChangeHandler} value={frmData.city} />
                  {validation.touched.city && validation.errors.city && <small className="text-rose-600">{validation.errors.city}</small>}
                </div>
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-3">
                <div>
                  <Label className="text-sm">Billing State<span className="text-rose-600">*</span></Label>
                  <Input className="mt-1.5" name="state" type="text" placeholder="State" onChange={onChangeHandler} value={frmData.state} />
                  {validation.errors.state && <small className="text-rose-600">{validation.errors.state}</small>}
                </div>
                <div>
                  <Label className="text-sm">Billing Country<span className="text-rose-600">*</span></Label>
                  <Input className="mt-1.5" name="country" type="text" placeholder="Country" onChange={onChangeHandler} value={frmData.country} />
                  {validation.errors.country && <small className="text-rose-600">{validation.errors.country}</small>}
                </div>
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-3">
                <div>
                  <Label className="text-sm">Billing Address<span className="text-rose-600">*</span></Label>
                  <Input className="mt-1.5" name="address" type="text" placeholder="Address" onChange={onChangeHandler} value={frmData.address} />
                  {validation.errors.address && <small className="text-rose-600">{validation.errors.address}</small>}
                </div>
                <div>
                  <Label className="text-sm">Billing Additional Address</Label>
                  <Input className="mt-1.5" name="additional_address" type="text" placeholder="additional_address" onChange={onChangeHandler} value={frmData.additional_address} />
                </div>
                {/* additional_address */}
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-3">
                <div>
                  <Label className="text-sm">Billing Pincode<span className="text-rose-600">*</span></Label>
                  <Input className="mt-1.5" name="pincode" type="number" placeholder="Pincode" onChange={onChangeHandler} value={frmData.pincode} />
                  {validation.errors.pincode && <small className="text-rose-600">{validation.errors.pincode}</small>}
                </div>
                {/* <div>
                  <Label className="text-sm">Purchase Order No</Label>
                  <Input className="mt-1.5" name="po_no" type="text" placeholder="Enter your PO No or Ref No which will appear on invoice" onChange={onChangeHandler} value={frmData.po_no} />
                </div> */}
              </div>
              <div className="grid grid-cols-1 gap-4 sm:gap-3">
                {/* <div>
                  <Label className="text-sm">Billing Pincode<span className="text-rose-600">*</span></Label>
                  <Input className="mt-1.5" name="pincode" type="number" placeholder="Pincode" onChange={onChangeHandler} value={frmData.pincode} />
                  {validation.errors.pincode && <small className="text-rose-600">{validation.errors.pincode}</small>}
                </div> */}
                <div>
                  <Label className="text-sm">Purchase Order No</Label>
                  <Input className="mt-1.5" name="po_no" type="text" placeholder="Enter your PO No or Ref No which will appear on invoice" onChange={onChangeHandler} value={frmData.po_no} />
                </div>
              </div>
              <h3 className="text-lg font-semibold">Delivery Details</h3>
              <div className="flex items-center mb-3">
                <input
                  type="checkbox"
                  id="sameAsBilling"
                  checked={useSameAsBilling}
                  onChange={handleCheckboxChange}
                  className="mr-2 h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                />
                <label htmlFor="sameAsBilling" className="text-sm font-medium">Same as billing details</label>
              </div>
              {!useSameAsBilling && (
                <div className="space-y-4 sm:space-y-6">
                  {/* <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-3">
                    <div>
                      <Label className="text-sm">Delivery Name<span className="text-rose-600">*</span></Label>
                      <Input className="mt-1.5" placeholder="Name" name="name" onChange={onDeliveryChangeHandler} value={deliveryName} />
                    </div>
                    <div>
                      <Label className="text-sm">Delivery Email<span className="text-rose-600">*</span></Label>
                      <Input className="mt-1.5" type="email" name="email" placeholder="Email" onChange={onDeliveryChangeHandler} value={deliveryEmail} />
                    </div>
                  </div> */}
                  {/* <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-3">
                    <div>
                      <Label>Delivery Phone Number<span className="text-rose-600">*</span></Label>
                      <div className="mt-1.5 flex">
                        <span className="inline-flex items-center px-2.5 rounded-l-2xl border border-r-0 border-neutral-200 dark:border-neutral-700 bg-slate-100 dark:bg-neutral-800 text-neutral-500 dark:text-neutral-400 text-sm">
                          <i className="text-2xl las la-phone-volume"></i>
                        </span>
                        <Input name="mobile" className="!rounded-l-none" placeholder="003 888 232" onChange={onDeliveryChangeHandler} value={deliveryMobile} />
                      </div>
                    </div>
                    <div>
                      <Label className="text-sm">Delivery Company</Label>
                      <Input className="mt-1.5" name="company" type="text" placeholder="Company" onChange={onDeliveryChangeHandler} value={deliveryCompany} />
                    </div>
                  </div> */}
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-3">
                    <div>
                      <Label className="text-sm">Delivery Company</Label>
                      <Input className="mt-1.5" name="company" type="text" placeholder="Company" onChange={onDeliveryChangeHandler} value={deliveryCompany} />
                    </div>
                    <div>
                      <Label className="text-sm">Delivery City<span className="text-rose-600">*</span></Label>
                      <Input className="mt-1.5" name="city" type="text" placeholder="City" onChange={onDeliveryChangeHandler} value={deliveryCity} />
                    </div>
                  </div>
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-3">
                    <div>
                      <Label className="text-sm">Delivery State<span className="text-rose-600">*</span></Label>
                      <Input className="mt-1.5" name="state" type="text" placeholder="State" onChange={onDeliveryChangeHandler} value={deliveryState} />
                    </div>
                    <div>
                      <Label className="text-sm">Delivery Country<span className="text-rose-600">*</span></Label>
                      <Input className="mt-1.5" name="country" type="text" placeholder="Country" onChange={onDeliveryChangeHandler} value={deliveryCountry} />
                    </div>
                  </div>
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-3">
                    <div>
                      <Label className="text-sm">Delivery Address<span className="text-rose-600">*</span></Label>
                      <Input className="mt-1.5" name="address" type="text" placeholder="Address" onChange={onDeliveryChangeHandler} value={deliveryAddress} />
                    </div>
                    <div>
                      <Label className="text-sm">Delivery Additional Address</Label>
                      <Input className="mt-1.5" name="additional_address" type="text" placeholder="additional_address" onChange={onDeliveryChangeHandler} value={deliveryAdditionalAddress} />
                    </div>
                  </div>
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-3">
                    <div>
                      <Label className="text-sm">Delivery Pincode<span className="text-rose-600">*</span></Label>
                      <Input className="mt-1.5" name="pincode" type="number" placeholder="Pincode" onChange={onDeliveryChangeHandler} value={deliveryPincode} />
                    </div>
                  </div>
                </div>
              )}
              {/* <div className="grid grid-cols-1">
                <label className="block">
                  <Label>Message<span className="text-rose-600">*</span></Label>
                  <Textarea className="mt-1" name="message" placeholder="Comment" rows={6} onChange={onChangeHandler} value={frmData.message} />
                  {validation.errors.message && <small className="text-rose-600">{validation.errors.message}</small>}
                </label>
              </div> */}
            </div>
          </div>
        </div>
      </div>
    );
  };

  const renderCartFrom = () => {
    if (isLoading) {
      // Show loader while fetching cart data
      return (
        <div className="flex justify-center items-center h-64">
          <SkewLoader color={color} loading={isLoading} />
        </div>
      );
    }

    return (
      <div className="flex flex-col lg:flex-row">
        {showSuccessPopup ? (
          <div className="container mx-auto p-6">
            <div className="bg-gray-100 rounded-lg shadow-md text-center p-10 mx-6">
              <div className="flex flex-col items-center justify-center">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" className="w-10 h-10 inline-block align-middle mr-2">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M9 12.75 11.25 15 15 9.75M21 12c0 1.268-.63 2.39-1.593 3.068a3.745 3.745 0 0 1-1.043 3.296 3.745 3.745 0 0 1-3.296 1.043A3.745 3.745 0 0 1 12 21c-1.268 0-2.39-.63-3.068-1.593a3.746 3.746 0 0 1-3.296-1.043 3.745 3.745 0 0 1-1.043-3.296A3.745 3.745 0 0 1 3 12c0-1.268.63-2.39 1.593-3.068a3.745 3.745 0 0 1 1.043-3.296 3.746 3.746 0 0 1 3.296-1.043A3.746 3.746 0 0 1 12 3c1.268 0 2.39.63 3.068 1.593a3.746 3.746 0 0 1 3.296 1.043 3.746 3.746 0 0 1 1.043 3.296A3.745 3.745 0 0 1 21 12Z" />
                </svg>
                <h2 className="text-black-600 text-xl font-medium mb-3 mt-4"> Many thanks for confirming the order against your purchase order no : <b>{useSameAsBilling ? frmData.po_no : deliveryPoNo}</b></h2>
              </div>
              <div className="space-y-2">
                <p>Your order No is <b>{odooOrderName || razorpayOrderId || "N/A"}</b>, amounting to ₹ <b>{paymentValue ? (Number(paymentValue)).toFixed(2) : "0.00"}</b> which has been processed at our end.</p>
                <p>We thank you for your trust & will dispatch the products as per the lead time mentioned in Quotation.</p>
                <p>Pl. note we will not be able to cancel or change the order, once the order confirmation is generated.</p>
              </div>
              <button className="inline-block px-4 py-2 bg-black text-white rounded-md text-center font-semibold text-lg hover:bg-blue-600 transition duration-300 mt-5" onClick={() => navigate('/')}>
                Go to Home Page
              </button>
            </div>
          </div>
        ) : cart.length > 0 ? ( // Changed from cartCount > 0 to cart.length > 0
          <>
            <form onSubmit={handleSubmit} method="post">
              <div className="flex-1">{renderLeft()}</div>
              {showTotalPrice && (
                <div className="flex flex-col items-start gap-3 mt-5">
                  {/* Part Delivery Checkbox */}
                  {/* <div className="flex items-center mb-2">
                      <input
                        type="checkbox"
                        id="partDelivery"
                        checked={partDeliveryChoice === "yes"}
                        onChange={(e) => setPartDeliveryChoice(e.target.checked ? "yes" : "no")}
                        className="mr-2 h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                      />
                      <label htmlFor="partDelivery" className="text-md font-medium">
                        Are you willing to accept part delivery?
                      </label>
                    </div> */}
                  <div className="flex items-center flex-wrap justify-end gap-3">
                    <button
                      type="submit"
                      name="confirm"
                      className="bg-black text-white rounded-full px-4 py-2 hover:border-black hover:border-2 focus:outline-none focus:ring-2 focus:ring-black"
                      onClick={handleCheckoutClick}
                      disabled={razorpayLoading || isConfirmLoading}
                    >
                      {isConfirmLoading ? "Processing..." : razorpayLoading ? "Loading Razorpay..." : "Confirm order"}
                    </button>
                    {isConfirmLoading && (
                      <div className="fixed inset-0 bg-white bg-opacity-75 z-50 flex items-center justify-center">
                        <div className="absolute z-50">
                          <SkewLoader color={color} loading={isConfirmLoading} />
                        </div>
                      </div>
                    )}
                    <button
                      type="button"
                      name="quotationpdf"
                      className="bg-black text-white rounded-full px-4 py-2 hover:border-black hover:border-2 focus:outline-none focus:ring-2 focus:ring-black"
                      onClick={handleQuotationClick}
                    >
                      Get Quotation by Email
                    </button>
                    <button
                      type="submit"
                      name="morehelp"
                      className="bg-black text-white rounded-full px-4 py-2 hover:border-black hover:border-2 focus:outline-none focus:ring-2 focus:ring-black"
                      onClick={handleMoreHelpClick}
                    >
                      Need More Help?
                    </button>
                    {razorpayError && <p className="text-rose-600">Error loading Razorpay: {razorpayError}</p>}
                  </div>
                </div>
              )}
            </form>
            <div className="flex-shrink-0 border-t lg:border-t-0 lg:border-l border-slate-200 dark:border-slate-700 my-10 lg:my-0 lg:mx-10 xl:lg:mx-14 2xl:mx-16"></div>
            {/* Right Section - Delivery Partner + Order Summary */}
            <div className="w-full lg:w-[36%] space-y-6">
              {/* Order Summary */}
              <div className="bg-white dark:bg-slate-900 shadow-md rounded-2xl p-6 border border-slate-200 dark:border-slate-700">
                <h3 className="text-lg font-semibold mb-4 flex items-center gap-2">
                  Order Summary
                </h3>

                {/* Totals (Shown Above) */}
                {showTotalPrice && (
                  <div className="space-y-3 bg-gray-100 dark:bg-slate-800 rounded-xl p-4 border border-slate-200 dark:border-slate-700 mb-5">
                    <div className="flex justify-between text-sm">
                      <span className="text-black font-medium dark:text-white">
                        {cartData?.discount > 0
                          ? "Sub Total (Before Discount)"
                          : "Sub Total"}
                      </span>
                      <span className="text-black font-medium dark:text-white">
                        ₹ {cartData?.subtotal?.toFixed(2) || 0}
                      </span>
                    </div>

                    {cartData?.discount > 0 && (
                      <div className="flex justify-between text-sm">
                        <span className="text-black font-medium dark:text-white">Discount</span>
                        <span className="text-black font-medium dark:text-white">
                          ₹ {cartData.discount.toFixed(2)}
                        </span>
                      </div>
                    )}

                    {cartData?.discount > 0 && (
                      <div className="flex justify-between text-sm">
                        <span className="text-black font-medium dark:text-white">Sub Total (After Discount)</span>
                        <span className="text-black font-medium dark:text-white">
                          ₹ {(cartData?.subtotal - cartData.discount).toFixed(2)}
                        </span>
                      </div>
                    )}

                    <div className="flex justify-between text-sm">
                      <span className="text-black font-medium dark:text-white">Freight Charge for ({cartData?.weight?.toFixed(3) || 0} kg)</span>
                      <span className="text-black font-medium dark:text-white">
                        ₹ {cartData?.delivery_charges?.toFixed(2) || 0}
                      </span>
                    </div>

                    <div className="flex justify-between text-sm">
                      <span className="text-black font-medium dark:text-white">GST Charge</span>
                      <span className="text-black font-medium dark:text-white">
                        ₹ {cartData?.gst?.toFixed(2) || 0}
                      </span>
                    </div>

                    <div className="flex justify-between text-sm">
                      <span className="text-black font-medium dark:text-white">Round Off. Amount</span>
                      <span className="text-black font-medium dark:text-white">
                        ₹ {((cartData?.total || 0) - (cartData?.totalBeforeRound || 0)).toFixed(2)}
                      </span>
                    </div>

                    {/* <div className="flex justify-between text-sm">
                        <span className="text-black font-medium dark:text-white">Total Weight</span>
                        <span className="text-black font-medium dark:text-white">
                          {cartData?.weight?.toFixed(3) || 0} kg
                        </span>
                      </div> */}

                    <div className="flex justify-between text-base font-semibold border-t border-slate-300 dark:border-slate-600 pt-3">
                      <span className="text-black font-medium dark:text-white">Total</span>
                      <span className="text-black font-medium dark:text-white">
                        ₹ {(cartData?.total || 0).toFixed(2)}
                      </span>
                    </div>
                  </div>
                )}

                {/* Accordion: Display the Product */}
                <div className="border-t border-slate-200 dark:border-slate-700 pt-4">
                  <button
                    onClick={() => setShowProducts(!showProducts)}
                    className="w-full flex justify-between items-center text-left font-semibold text-gray-700 dark:text-gray-200"
                  >
                    <span>Display the Product</span>
                    <i
                      className={`las ${showProducts ? "la-angle-up" : "la-angle-down"} text-xl`}
                    ></i>
                  </button>

                  {showProducts && (
                    <div className="mt-4 space-y-4 divide-y divide-slate-200 dark:divide-slate-700">
                      {cartData?.detailed_codes?.map((item: any, index: number) => (
                        <div key={index} className="pt-4 flex items-center justify-between">
                          <div>
                            <h4 className="font-medium">{item.code}</h4>
                            <p className="text-xs text-gray-500">Qty: {item.quantity}</p>
                            {item.discount > 0 && (
                              <p className="text-xs text-gray-500">Discount: {item.discount}%</p>
                            )}
                            <p className="text-xs text-gray-500">
                              GST:{" "}
                              {(() => {
                                const m = String(item.GST ?? "").match(/(\d+(\.\d+)?)%/);
                                return m ? `${m[1]}%` : "0%";
                              })()}
                            </p>
                            <p className="text-xs text-gray-500">
                              Weight: {(item.weight * item.quantity).toFixed(3)} kg
                            </p>
                          </div>
                          <div className="text-right">
                            <p className="font-semibold text-sm">
                              ₹ {(item.price * item.quantity).toFixed(2)}
                            </p>
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </>
        ) : (
          <>
            <div style={{
              backgroundColor: 'white',
              color: 'black',
              padding: '20px',
              borderRadius: '8px',
              textAlign: 'center',
              maxWidth: '400px',
              margin: '30px auto',
              border: '1px solid #ccc',
              boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
            }}>
              <h1 style={{ marginBottom: '20px', fontWeight: 'bold' }}>Your cart is empty!</h1>
              <div className="pt-8">
                <button className="bg-black text-white rounded-full px-4 py-2 hover:bg-blue-600 transition duration-300" onClick={() => navigate('/category')}>
                  Shop now
                </button>
              </div>
            </div>


          </>
        )}
      </div>
    );
  };

  return (
    <div className="nc-CheckoutPage">
      {/* Add the SkewLoader overlay for quotation loading */}
      {isQuotationLoading && (
        <div className="fixed inset-0 bg-white bg-opacity-75 z-50 flex items-center justify-center">
          <div className="absolute z-50">
            <SkewLoader color={color} loading={isQuotationLoading} />
          </div>
        </div>
      )}

      {showPartDeliveryPopup && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">
          <div className="bg-white rounded-lg p-8 shadow-xl w-full max-w-md relative">
            {/* Close button (optional) */}
            <button
              className="absolute top-3 right-4 text-gray-500 hover:text-gray-800 text-2xl"
              onClick={() => setShowPartDeliveryPopup(false)}
            >
              ×
            </button>

            {/* <h2 className="text-xl font-semibold mb-6 text-center">
              Part Delivery Confirmation
            </h2> */}

            <p className="text-center mb-8 text-gray-700">
              Do you wish to receive the part delivery of ready product
            </p>

            <div className="flex justify-center gap-6">
              <button
                onClick={() => {
                  setPartDeliveryChoice("yes");
                  setShowPartDeliveryPopup(false);
                  // Important: give React time to update state
                  setTimeout(() => {
                    validation.handleSubmit();
                  }, 0);
                }}
                className="bg-green-600 hover:bg-green-700 text-white px-8 py-3 rounded-lg font-medium min-w-[120px]"
              >
                Yes
              </button>

              <button
                onClick={() => {
                  setPartDeliveryChoice("no");
                  setShowPartDeliveryPopup(false);
                  setTimeout(() => {
                    validation.handleSubmit();
                  }, 0);
                }}
                className="bg-gray-600 hover:bg-gray-700 text-white px-8 py-3 rounded-lg font-medium min-w-[120px]"
              >
                No
              </button>
            </div>


          </div>
        </div>
      )}

      {showMoreHelpPopup && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">
          <div className="bg-white rounded-lg p-8 shadow-lg w-full max-w-md relative">
            <button
              className="absolute top-2 right-2 text-gray-500 hover:text-black"
              onClick={() => setShowMoreHelpPopup(false)}
              aria-label="Close"
            >
              &times;
            </button>
            <h2 className="text-xl font-semibold mb-4">More Help</h2>
            <label className="block mb-2 font-medium">
              Please select an issue<span className="text-rose-600">*</span>
            </label>
            <div className="mb-4 space-y-2">
              <label className="flex items-center">
                <input
                  type="radio"
                  name="moreHelpOption"
                  value="Need Help with the delivery / Lead Time of the Product"
                  checked={moreHelpMessage === "Need Help with the delivery / Lead Time of the Product"}
                  onChange={() => setMoreHelpMessage("Need Help with the delivery / Lead Time of the Product")}
                  className="mr-2"
                />
                Need Help with the delivery / Lead Time of the Product
              </label>
              <label className="flex items-center">
                <input
                  type="radio"
                  name="moreHelpOption"
                  value="Delivery Partner not listed"
                  checked={moreHelpMessage === "Delivery Partner not listed"}
                  onChange={() => setMoreHelpMessage("Delivery Partner not listed")}
                  className="mr-2"
                />
                Delivery Partner not listed
              </label>
              <label className="flex items-center">
                <input
                  type="radio"
                  name="moreHelpOption"
                  value="Concern regarding Price"
                  checked={moreHelpMessage === "Concern regarding Price"}
                  onChange={() => setMoreHelpMessage("Concern regarding Price")}
                  className="mr-2"
                />
                Concern regarding Price
              </label>
              <label className="flex items-center">
                <input
                  type="radio"
                  name="moreHelpOption"
                  value="Product not listed on website"
                  checked={moreHelpMessage === "Product not listed on website"}
                  onChange={() => setMoreHelpMessage("Product not listed on website")}
                  className="mr-2"
                />
                Product not listed on website
              </label>
              <label className="flex items-center">
                <input
                  type="radio"
                  name="moreHelpOption"
                  value="Other issue"
                  checked={
                    moreHelpMessage !== "Need Help with the delivery / Lead Time of the Product" &&
                    moreHelpMessage !== "Delivery Partner not listed" &&
                    moreHelpMessage !== "Concern regarding Price" &&
                    moreHelpMessage !== "Product not listed on website"
                  }
                  onChange={() => setMoreHelpMessage("")}
                  className="mr-2"
                />
                Other issue
              </label>
            </div>
            {/* Show textarea only if "Other issue" is selected */}
            {moreHelpMessage !== "Need Help with the delivery / Lead Time of the Product" &&
              moreHelpMessage !== "Delivery Partner not listed" &&
              moreHelpMessage !== "Concern regarding Price" &&
              moreHelpMessage !== "Product not listed on website" && (
                <Textarea
                  className="w-full mb-2"
                  name="moreHelpMessage"
                  rows={5}
                  placeholder="Enter your message"
                  value={moreHelpMessage}
                  onChange={(e) => setMoreHelpMessage(e.target.value)}
                />
              )}
            {moreHelpError && <p className="text-rose-600 mb-2">{moreHelpError}</p>}
            <div className="flex justify-end gap-3 mt-4">
              <button
                className="bg-gray-300 text-black rounded px-4 py-2"
                onClick={() => setShowMoreHelpPopup(false)}
                disabled={moreHelpLoading}
              >
                Cancel
              </button>
              <button
                className="bg-black text-white rounded px-4 py-2"
                onClick={handleMoreHelpSubmit}
                disabled={moreHelpLoading}
              >
                {moreHelpLoading ? "Submitting..." : "Submit"}
              </button>
            </div>
          </div>
        </div>
      )}
      <Helmet>
        <title>Checkout | Vijaydeep</title>
      </Helmet>
      <main className="container py-16 lg:pb-28 lg:pt-20">
        <div className="mb-16">
          <h2 className="block text-2xl sm:text-3xl lg:text-4xl font-semibold">
            Checkout
          </h2>
          <div className="block mt-3 sm:mt-5 text-xs sm:text-sm font-medium text-slate-700 dark:text-slate-400">
            <Link to={"/"} className="">Homepage</Link>
            <span className="text-xs mx-1 sm:mx-1.5">/</span>
            <span className="underline">Checkout</span>
          </div>
        </div>
        {renderCartFrom()}
      </main>
    </div>
  );
};

export default CheckoutPage;